// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LightBoxPreview_wrapper__16yth","thumbnail":"LightBoxPreview_thumbnail__1vhDw","hoverImage":"LightBoxPreview_hoverImage__3Ugh0","btn":"LightBoxPreview_btn__2Xy5f"};